import React, { Component } from 'react'
import "../styles/ProjectCardImage.css";

export default class ProjectCardImage extends Component {
    render() {
        return (
            <div className="projectImgCardWrapper">
                <img src={this.props.source} alt = {this.props.alt}></img>
            </div>
        )
    }
}
